import { DDSBodyText, DDSButton, DDSMicroText } from "@web-monorepo/dds";
import { clsx } from "clsx";
import styles from "./ToolkitGridItem.module.css";

type ToolkitGridItemProps = {
  index: number;
  title: string;
  subTitle?: string;
  imgSrc?: string;
  onItemClick: VoidFunction;
  imgZoomed?: boolean;
  noBorder?: boolean;
};

function ToolkitGridItem(props: ToolkitGridItemProps) {
  return (
    <div>
      {/* The button's accessible name comes from the thumbnail's `alt` (set to
          the title) since DDSButton's typed API doesn't take `aria-label`. */}
      <DDSButton
        type="button"
        variant="unstyled"
        data-name={`toolkit_grid_item:${props.index}`}
        className={clsx(styles.imageButton, !props.noBorder && styles.imageButtonBordered)}
        onClick={() => props.onItemClick()}
      >
        <img
          src={props.imgSrc}
          alt={props.title}
          className={clsx(styles.image, props.imgZoomed && styles.imageZoomed)}
        />
      </DDSButton>
      <div className={styles.text}>
        <DDSBodyText>{props.title}</DDSBodyText>
        {props.subTitle && <DDSMicroText className={styles.subTitle}>{props.subTitle}</DDSMicroText>}
      </div>
    </div>
  );
}

export default ToolkitGridItem;
